/** One tab of an inspector set out in tabs (see `InspectorTabs.vue`). */
export interface InspectorTab<Id extends string = string> {
  readonly id: Id
  readonly label: string
  /** Its pictogram, as path data on a 16-unit square. */
  readonly icon?: readonly string[] | undefined
  /** How many things the tab holds, shown beside its name. */
  readonly count?: number | undefined
}

/** The pictograms the tabs use, so the same idea always looks the same. */
export const TAB_ICONS = {
  add: ['M8 3.5v9M3.5 8h9'],
  layers: ['M8 2.5l5.5 3-5.5 3-5.5-3z', 'M2.5 8.5l5.5 3 5.5-3', 'M2.5 11.5l5.5 3 5.5-3'],
  element: ['M4 2.5l8.5 5-3.8 1 2 4.2-1.6.8-2-4.2-3.1 2.7z'],
  arrange: ['M8 2v12M2 8h12', 'M6 4l2-2 2 2M6 12l2 2 2-2M4 6l-2 2 2 2M12 6l2 2-2 2'],
  data: ['M2.5 3.5h11v9h-11z', 'M2.5 6.5h11M6.5 3.5v9'],
  cells: ['M2.5 3.5h11v9h-11z', 'M2.5 6.5h11M2.5 9.5h11M6.5 3.5v9M10 3.5v9'],
  look: [
    'M8 2.5a5.5 5.5 0 1 0 0 11c.9 0 1.3-.6 1.1-1.3-.3-.9.3-1.7 1.2-1.7h1.2a2 2 0 0 0 2-2A5.5 5.5 0 0 0 8 2.5z',
    'M5.3 7.3h.01M7.1 5h.01M10 5.3h.01',
  ],
  lines: ['M5.5 4.5h8M5.5 8h8M5.5 11.5h8', 'M2.5 4.5h.01M2.5 8h.01M2.5 11.5h.01'],
  settings: ['M2.5 4.5h11M2.5 11.5h11', 'M5.5 3v3M10.5 10v3'],
  format: ['M4 12.5L8 3l4 9.5M5.5 9h5', 'M3 14.5h10'],
  layout: ['M2.5 3.5h4.5v9h-4.5z', 'M9 3.5h4.5v9H9z'],
  chart: ['M3.5 13V8.5M6.5 13V4.5M9.5 13V7M12.5 13V10', 'M2 13.5h12'],
  globe: [
    'M8 2.5a5.5 5.5 0 1 0 0 11a5.5 5.5 0 1 0 0-11z',
    'M2.5 8h11',
    'M8 2.5c-1.6 1.6-2.4 3.4-2.4 5.5s.8 3.9 2.4 5.5c1.6-1.6 2.4-3.4 2.4-5.5S9.6 4.1 8 2.5z',
  ],
  upload: ['M8 10.5V3M5 5.5l3-3 3 3', 'M3 10.5V13h10v-2.5'],
} as const satisfies Record<string, readonly string[]>
